import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import { merge } from 'immutable';

import './style.scss';

const NewsRecent = ({ entities, userSelectedEntities }) => {

  // Normalize, merge and slice the View entities with the User selected entities.
  const displayedEntities = userSelectedEntities ? merge(
    userSelectedEntities.map((a) => a.get('entity')),
    entities,
  ) : entities;

  return (
    <div className="View NewsRecent">
      <div className="row no-gutters">
        {displayedEntities.slice(0, 3).map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 col-md-4 NewsRecent__item-wrapper';

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
                showPinned
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NewsRecent;
